<div class="container">
    <h2>Edit Dish</h2>
    <form action="" method="POST">

      <div class="form-group">
        <label for="id">Dish _id:</label>
        <p>{{searchedId}}</p>
      </div>

      <div class="form-group">
        <label for="name">Edit Dish's Name:</label>
        <input type="text" class="form-control" name="name" 
        value="{{editName}}" #name
        (change)="changeName(name.value)">
      </div>

      <div class="form-group">
        <label for="description">Edit Dish's Description:</label>
        <input type="text" class="form-control" name="description" 
        value="{{editDescription}}" #description
        (change)="changeDescription(description.value)">
      </div>

      <div class="form-group">
        <label for="price">Edit Dish's Price</label>
        <input type="number" class="form-control" name="price"
        value="{{editPrice}}" #price
        (change)="changePrice(price.value)">
      </div>
      <button type="submit" class="btn btn-primary" (click)="onUpdate($event)">Submit</button>
    </form>
  </div>